import { Card, Typography } from "@codat/orchard-ui";
import classNames from "classnames";

import styles from "./ErrorCard.module.css";

const getErrorTitle = (errorCode: number) => {
  switch (errorCode) {
    case 400:
      return "Bad Request";
    case 404:
      return "Page doesn't exist";
    case 402:
      return "License limit for linking companies reached";
    case 500:
    default:
      return "Something went wrong";
  }
};

export const ErrorCard = ({
  errorCode = 500,
  correlationId,
  errorMessage,
}: React.PropsWithChildren<{
  errorCode?: number;
  correlationId?: string | null;
  errorMessage?: string | null;
}>) => {
  return (
    <Card>
      <div
        data-testid="error-card"
        className={classNames(styles.content, styles.centered)}
      >
        <header className={styles.header}>
          <Typography
            variant="extraLarge"
            as="p"
            data-testid="error-card-header"
          >
            {errorCode}
          </Typography>
        </header>
        <div className={classNames(styles.body, styles.centered)}>
          <Typography
            variant="h2"
            as="h2"
            className={styles.title}
            data-testid="error-card-title"
          >
            {errorMessage || getErrorTitle(errorCode)}
          </Typography>
          {correlationId && (
            <Typography
              variant="small"
              as="p"
              data-testid="error-card-correlation-id"
            >
              {correlationId}
            </Typography>
          )}
        </div>
      </div>
    </Card>
  );
};
